module.exports = __webpack_public_path__ + "img/teacher-answer-bg.05302475.png";